import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";
import { Lock, ShieldCheck, KeyRound, ArrowRight } from "lucide-react";

export default function Landing() {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Navbar />

      {/* Hero — short and clear */}
      <section className="relative flex-1 flex items-center">
        <div className="absolute inset-0 bg-dots opacity-60 pointer-events-none" />
        <div className="relative max-w-3xl mx-auto px-6 py-20 text-center">
          <Badge
            variant="outline"
            className="mb-6 border-emerald-200 bg-emerald-50 text-emerald-700 px-3 py-1"
            data-testid="hero-trust-badge"
          >
            <Lock className="w-3.5 h-3.5 mr-1.5" /> Free • Your info stays locked
          </Badge>

          <h1 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl text-slate-950 leading-[1.05] tracking-tight">
            Build a resume.
            <br />
            <span className="relative inline-block">
              <span className="relative z-10">Keep it safe.</span>
              <span className="absolute inset-x-0 bottom-1 h-3 bg-blue-100 -z-0" />
            </span>
          </h1>

          <p className="mt-5 text-lg text-slate-600 max-w-xl mx-auto leading-relaxed">
            A simple, free resume builder. Your info is locked up tight before
            we save it — only you can open it.
          </p>

          <div className="mt-8 flex justify-center gap-3 flex-wrap">
            <Link to="/register">
              <Button
                size="lg"
                className="bg-slate-900 hover:bg-slate-800 h-12 px-6"
                data-testid="hero-cta-primary"
              >
                Start my resume <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
            </Link>
            <Link to="/login">
              <Button
                size="lg"
                variant="outline"
                className="h-12 px-6"
                data-testid="hero-cta-secondary"
              >
                Sign in
              </Button>
            </Link>
          </div>

          {/* Small security strip */}
          <div className="mt-12 flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-sm text-slate-500">
            <span className="flex items-center gap-2">
              <Lock className="w-4 h-4 text-emerald-500" /> Locked storage
            </span>
            <span className="flex items-center gap-2">
              <ShieldCheck className="w-4 h-4 text-emerald-500" /> Private to you
            </span>
            <span className="flex items-center gap-2">
              <KeyRound className="w-4 h-4 text-emerald-500" /> No ads, no fees
            </span>
          </div>
        </div>
      </section>

      <footer className="border-t border-slate-100 py-6 text-center text-sm text-slate-500">
        © {new Date().getFullYear()} ResumeLock — Free and private.
      </footer>
    </div>
  );
}
